import { request, solomonBaseUrl } from '@/libs/api-request'
import httpClientHub from '@/libs/http-client-hub'
import axios from 'axios'
import { HTTP_STATUS } from '@/libs/constants'

let aborter = new AbortController()
const authFailedStatus = [ HTTP_STATUS.unauthrized ]

export function getMineListData (params) {
  const url = '/v1/samsung/heatmap/ai/mine_list'

  return httpClientHub.post(url, params).then(response => {
    return response.data
  }).catch(error => {
    console.log('getMineListData error:', error)
    return error
  })
}

export function getMineCount (lang) {
  const url = `/v1/samsung/heatmap/ai/mine_count/${lang}`

  return httpClientHub.get(url).then(response => {
    return response.data
  }).catch(error => {
    console.log('getMineCount error:', error)
    return error
  })
}

export const editReportTitle = (params, force = true) => {
  const url = '/v1/samsung/heatmap/ai/update_title'

  return httpClientHub.post(url, params).then(response => {
    return response.data
  }).catch(error => {
    console.log('editReportTitle error:', error)
    return error
  })
}

export function docentCheck (params) {
  const url = '/v1/samsung/heatmap/ai/docent_check'

  return httpClientHub.post(url, params).then(response => {
    return response.data
  }).catch(error => {
    console.log('docentCheck error:', error)
    return error
  })
}

export function docentStop (params) {
  const url = '/v1/samsung/heatmap/ai/docent_stop'

  const reqParams = {
    ...params,
    sessionKey: sessionStorage.getItem('reportchat_sessionKey')
  }
  return httpClientHub.post(url, reqParams).then(response => {
    return response.data
  }).catch(error => {
    console.log('docentStop error:', error)
    return error
  })
}

export async function connect (onConnect = false, category = 'reportchat') {
  return new Promise((resolve, reject) => {
    axios
      .get(`${solomonBaseUrl()}/hello`)
      .then((res) => {
        const accessToken = res.data.access_token
        const refreshToken = res.data.refresh_token
        const sessionKey = res.data.res.data

        if (accessToken) sessionStorage.setItem(`${category}_accessToken`, accessToken)
        if (refreshToken) sessionStorage.setItem(`${category}_refreshToken`, refreshToken)
        if (sessionKey) sessionStorage.setItem(`${category}_sessionKey`, sessionKey)

        resolve()
      })
      .catch((e) => {
        if (authFailedStatus.includes(e.response && e.response.status)) {
          refresh(onConnect, category)
        }
        reject(new Error(e))
      })
  })
}

export function refresh (onConnect = false, category = 'reportchat') {
  const config = {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem(
        'reportchat_refreshToken'
      )}`
    },
    withCredentials: true
  }

  axios
    .get(`${solomonBaseUrl()}/refresh`, config)
    .then((res) => {
      const accessToken = res.data.access_token
      sessionStorage.setItem(`${category}_accessToken`, accessToken)
    })
    .catch((e) => {
      console.log(e)
      if (authFailedStatus.includes(e.response && e.response.status)) {
        sessionStorage.removeItem(`${category}_accessToken`)
        sessionStorage.removeItem(`${category}_refreshToken`)
        sessionStorage.removeItem(`${category}_sessionKey`)
        connect(onConnect, category)
      }
    })
}

export const setReportForChat = (data) => {
  const config = {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem('reportchat_accessToken')}`
    }
  }
  return axios.post(`${solomonBaseUrl()}/question/set_report`, data, config)
}

export async function askQuestion (data, onStart, onDataCallback, onEnd) {
  aborter.abort()
  aborter = new AbortController()

  let headers = {
    Authorization: `Bearer ${sessionStorage.getItem('reportchat_accessToken')}`,
    'Content-Type': 'application/json'
  }

  fetch(`${solomonBaseUrl()}/question/ask`, {
    credentials: 'include',
    signal: aborter.signal,
    method: 'POST',
    headers,
    body: JSON.stringify(data)
  })
    .then((response) => {
      if (!response.ok) {
        if (authFailedStatus.includes(response.status)) {
          onEnd(null, 'error')
          refresh()
        }
        throw response
      }

      return response
    })
    .then(async (response) => {
      onStart(response)

      const loopRunner = true
      const reader = response.body.getReader()
      const decoder = new TextDecoder()

      while (loopRunner) {
        const { done, value } = await reader.read()

        if (done) {
          onEnd(response)
          break
        }

        const decoded = decoder.decode(value, { stream: true })
        onDataCallback(decoded)
      }
    })
    .catch((e) => {
      if (aborter.signal.aborted) {
        console.log('Abort generation')
      }

      onEnd(null, e)
      console.log(e)
    })
}

export function abortRendering () {
  try {
    aborter.abort()
  } catch (e) {
    console.log(e)
  }
}

export const setSummary = (data) => {
  const config = {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem('reportchat_accessToken')}`
    }
  }
  return axios.post(`${solomonBaseUrl()}/question/insert_init_reportchat_row`, data, config)
}

export const rateAnswer = (data) => {
  const config = {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem('reportchat_accessToken')}`
    }
  }
  return axios.post(`${solomonBaseUrl()}/question/update_rating`, data, config)
}

export const getTokenStatus = (id) => {
  const config = {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem('reportchat_accessToken')}`
    }
  }
  return axios.get(`${solomonBaseUrl()}/question/get_token_for_reportchat?Id=${id}`, config)
}

export const resetReportChat = () => {
  const config = {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem('reportchat_accessToken')}`
    }
  }
  return axios.get(`${solomonBaseUrl()}/question/reset_report`, config)
    .then((res) => {
      const accessToken = res.data.access_token
      const refreshToken = res.data.refresh_token
      const sessionKey = res.data.res.data
      if (accessToken) sessionStorage.setItem('reportchat_accessToken', accessToken)
      if (refreshToken) sessionStorage.setItem('reportchat_refreshToken', refreshToken)
      if (sessionKey) sessionStorage.setItem('reportchat_sessionKey', sessionKey)
    })
    .catch((e) => {
      console.log(e)
    })
}

export function getSegmentOptions (params, force = true) {
  const url = '/ai/heatmap/get_segment_options'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getAIReportPlan (aiReportId, force = true) {
  const url = '/ai/journeymap/plan_list'

  const config = {
    method: 'get',
    url
  }

  return request(config, force)
}

export function checkReportDuplicate (params, force = true) {
  const url = '/ai/heatmap/report_check'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function retryReport (params, force = true) {
  const url = '/ai/heatmap/retry_report'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}
